<template>
  <Teleport to="body">
    <Transition name="modal">
      <div v-if="modelValue" class="modal-overlay" @click="handleOverlayClick">
        <div class="modal-content" :class="sizeClass" @click.stop>
          <!-- 헤더 -->
          <div v-if="$slots.header || title" class="modal-header">
            <div class="flex items-center justify-between">
              <div>
                <slot name="header">
                  <h3 class="text-lg font-semibold">{{ title }}</h3>
                  <p v-if="subtitle" class="text-sm text-gray-100 mt-1">
                    {{ subtitle }}
                  </p>
                </slot>
              </div>
              <button
                v-if="closable"
                @click="close"
                class="text-gray-100 hover:text-white transition-colors p-1 rounded"
              >
                <i class="fas fa-times"></i>
              </button>
            </div>
          </div>

          <!-- 본문 -->
          <div class="modal-body" :class="bodyClass">
            <slot></slot>
          </div>

          <!-- 푸터 -->
          <div v-if="$slots.footer" class="modal-footer">
            <slot name="footer"></slot>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script>
import { computed } from 'vue';

export default {
  name: 'BaseModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    subtitle: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: 'md',
      validator: value => ['sm', 'md', 'lg', 'xl'].includes(value),
    },
    closable: {
      type: Boolean,
      default: true,
    },
    closeOnOverlay: {
      type: Boolean,
      default: true,
    },
    bodyClass: {
      type: String,
      default: '',
    },
  },
  emits: ['update:modelValue', 'close'],
  setup(props, { emit }) {
    const sizeClass = computed(() => {
      const sizes = {
        sm: 'max-w-sm',
        md: 'max-w-md',
        lg: 'max-w-lg',
        xl: 'max-w-xl',
      };
      return sizes[props.size];
    });

    const close = () => {
      emit('update:modelValue', false);
      emit('close');
    };

    const handleOverlayClick = () => {
      if (props.closeOnOverlay) {
        close();
      }
    };

    return {
      sizeClass,
      close,
      handleOverlayClick,
    };
  },
};
</script>

<style scoped>
.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.3s ease;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

.modal-enter-active .modal-content,
.modal-leave-active .modal-content {
  transition: transform 0.3s ease;
}

.modal-enter-from .modal-content,
.modal-leave-to .modal-content {
  transform: scale(0.9) translateY(-20px);
}
</style>
